/**
 * Адреса службы графика (`src/Schedule/README.md`, HTTP API `/api/schedule/v1`). Литерал `/api/` законен только в файлах
 * `api/urls.ts` (eslint).
 */
const BASE = '/api/schedule/v1'

const segment = (value: string): string => encodeURIComponent(value)

export const SCHEDULE_URLS = {
  access: `${BASE}/access`,
  places: `${BASE}/places`,
  allAssignments: `${BASE}/assignments`,
  place: (placeId: string) => `${BASE}/places/${segment(placeId)}`,
  members: (placeId: string) => `${BASE}/places/${segment(placeId)}/members`,
  member: (placeId: string, cashierId: string) => `${BASE}/places/${segment(placeId)}/members/${segment(cashierId)}`,
  cashierDay: (placeId: string, date: string, cashierId: string) => `${BASE}/places/${segment(placeId)}/days/${segment(date)}/cashiers/${segment(cashierId)}`,
} as const
